export default __webpack_public_path__ + "static/media/1left.441d35af.png";